import { Routes, Route } from "react-router-dom";
import Labels from "./Labels";

const index = () => {
	return (
		<Routes>
			<Route index element={<Labels />} />
		</Routes>
	);
};

export default index;
